export default __webpack_public_path__ + "static/media/unsuported-chain.b91ab76d.svg";